export enum SelectFilterType {
	Companies = "companies",
	Candidates = "candidates",
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type TOnSelect = (selectFilterType: SelectFilterType, filterObject: any) => void;
